<!-- Sidebar navigation -->
<mdb-side-nav #sidenav class="fixed" [fixed]="true">
  <mdb-navbar-brand>
    <!-- Logo -->
    <li>
      <div class="logo-wrapper waves-light mx-auto text-center">
        <a (click)="handleGoTo('/')">
          <img [alt]="'logo ' + logo" class="img-fluid mx-lg-auto" (error)="logo = './../../content/images/logos/demo/demo-sidenav.png'" [src]="logo" />
        </a>
      </div>
    </li>
    <!--/. Logo -->
  </mdb-navbar-brand>

  <!--Social-->
  <li>
    <ul class="social">
      <li *ngIf="transporter && transporter.facebook">
        <a class="icons-sm fb-ic" [href]="transporter.facebook" target="_blank">
          <jhi-bary-icon icon="facebook-f" [faDirective]="FAB"></jhi-bary-icon>
        </a>
      </li>
      <li *ngIf="transporter && transporter.twitter">
        <a class="icons-sm tw-ic" [href]="transporter.twitter" target="_blank">
          <jhi-bary-icon icon="twitter" [faDirective]="FAB"></jhi-bary-icon>
        </a>
      </li>
      <li *ngIf="transporter && transporter.youtube">
        <a class="icons-sm yt-ic" [href]="transporter.youtube" target="_blank">
          <jhi-bary-icon icon="youtube" [faDirective]="FAB"></jhi-bary-icon>
        </a>
      </li>
      <li *ngIf="transporter && transporter.linkedin">
        <a class="icons-sm lk-ic" [href]="transporter.linkedin" target="_blank">
          <jhi-bary-icon icon="linkedin-in" [faDirective]="FAB"></jhi-bary-icon>
        </a>
      </li>
    </ul>
  </li>
  <!--/Social-->

  <!-- USER -->
  <!-- Side navigation links -->
  <ul class="collapsible collapsible-accordion" *ngIf="hasOnlyRole(_authority.USER) || isImpersonating">
    <mdb-accordion [multiple]="false" aria-multiselectable="false">
      <jhi-bary-sidebar-accordion-user></jhi-bary-sidebar-accordion-user>
      <!-- Legal Mention and FAQ (disabled) -->
      <jhi-bary-sidebar-footer></jhi-bary-sidebar-footer>
      <!-- /Legal Mention and FAQ -->
    </mdb-accordion>
  </ul>

  <!-- ADMIN -->
  <!-- Side navigation links -->
  <ul class="collapsible collapsible-accordion" *ngIf="!isImpersonating && hasRole(_authority.ADMIN)">
    <mdb-accordion [multiple]="false" aria-multiselectable="false">
      <jhi-bary-sidebar-accordion-admin
        [swaggerEnabled]="swaggerEnabled"
        [inProduction]="inProduction"
        [transporters]="transporters"
        (goToEvent)="handleGoTo($event)"
      ></jhi-bary-sidebar-accordion-admin>
      <!-- Legal Mention and FAQ (disabled) -->
      <jhi-bary-sidebar-footer></jhi-bary-sidebar-footer>
      <!-- /Legal Mention and FAQ -->
    </mdb-accordion>
  </ul>

  <!-- MODERATOR -->
  <!-- Side navigation links -->
  <ul class="collapsible collapsible-accordion" *ngIf="hasRole(_authority.MODERATOR)">
    <mdb-accordion [multiple]="false" aria-multiselectable="false">
      <jhi-bary-sidebar-accordion-moderator (goToEvent)="handleGoTo($event)"></jhi-bary-sidebar-accordion-moderator>
      <!-- Legal Mention and FAQ (disabled) -->
      <jhi-bary-sidebar-footer [isModerator]="true"></jhi-bary-sidebar-footer>
      <!-- /Legal Mention and FAQ -->
    </mdb-accordion>
  </ul>
  <!--/. Side navigation links -->
  <div class="sidenav-bg mask-strong"></div>
</mdb-side-nav>
<!--/. Sidebar navigation -->
